// if (location.host == "192.168.100.5") {

  
//   var api_base = "http://localhost/motap_test/api/admin_panel/"; 
// } else {
//   var api_base = "https://primexop.com/motap/api/admin_panel/";

// }

switch (location.host) {
  case "192.168.100.5":
    var api_base = 'http://192.168.100.5/multi_tournament_app/api/admin_panel/'
    var old_op_base="http://192.168.100.5/motap_test/op/"
    break;
  case "127.0.0.1:5502":
    var api_base = 'http://192.168.100.5/multi_tournament_app/api/admin_panel/'
    var old_op_base="http://192.168.100.5/motap_test/op/"
    break;


  default:
    var api_base = 'https://api.primexop.com/mta/admin_panel/'
    var old_op_base="https://alt.primexop.com/motap/op/"
}

//   console.log(api_base)



function  go_to_old_op(){
  location.href = old_op_base
}

